import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import CustomFeeRow from '../../../../components/CustomFeeRow';
import { useStyles } from './style';

interface ExamFeeProps {
  regNumber: string;
  totalExamFee: string;
  totalGst: string;
  totalFee: string;
}

const ExamFee = ({ feeDetails }: { feeDetails: ExamFeeProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { regNumber, totalExamFee, totalGst, totalFee } = feeDetails;

  return (
    <Grid container className={classes.container}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>ReviewExam.ExamFees')}
      </Typography>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            id="gstRegistrationNumber"
            keyText={t('components->>SelectedSubjectReview.GST Reg No.')}
            valueText={regNumber}
          />
        </Grid>
      </Grid>
      {/* Total Charges */}
      <CustomFeeRow
        variant="header"
        label={t('exam->>ReviewExam.TotalExamFees')}
        value={t('exam->>ReviewExam.AmountSGD')}
        currencyDenomination={false}
      />

      <CustomFeeRow label={t('exam->>ReviewExam.GST')} value={totalGst || '0.0'} />

      <CustomFeeRow label={t('exam->>ReviewExam.TotalInclGST')} value={totalExamFee || '0.0'} />

      <CustomFeeRow
        label={t('exam->>ReviewExam.TotalByCandidate')}
        value={totalFee || '0.0'}
        variant="footer"
      />
    </Grid>
  );
};
export default ExamFee;
